<template>
  <Icons
    :icon-height="57"
    :optional-coeff="-10"
    class="flex-shrink-0 no-drag"
    @setIcon="setIcon"
  >
    <div class="flex rounded-10 cursor-pointer border"
         :class="[{'bg-grey-580': isOutlined && isDarkMode}, isDarkMode ? 'border-project' : 'border-grey-580', size]"
    >
      <img class="m-auto" :class="iconSize" :src="iconSRC" alt="icon">
    </div>
  </Icons>
</template>

<script>
import { defineComponent, computed } from 'vue'
import Icons from '@/components/projects/Icons'
import { useStore } from 'vuex'

export default defineComponent({
  components: { Icons },

  props: {
    book: Object,
    size: { type: String, default: 'w-40 h-40' },
    iconSize: { type: String, default: 'w-2/3 h-2/3' }
  },

  setup (props) {
    const { dispatch, getters } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)

    const iconSRC = computed(() => {
      const icon = props.book.icon || 'default-phoenix'

      if (icon.includes('default-')) {
        return require(`@/assets/images/book-icons/${icon}.svg`)
      }

      return require(`@/assets/images/icons/${icon}.png`)
    })

    const isOutlined = computed(() => props.book.icon?.includes('outlined'))

    function setIcon (icon) {
      dispatch('editBook', {
        id: props.book.id,
        icon: icon
      })
    }

    return {
      // ref
      // computed
      iconSRC,
      isOutlined,
      isDarkMode,
      // function
      setIcon
    }
  }
})
</script>
